"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateBookingItemPriceExtraReducers = void 0;
const tslib_1 = require("tslib");
const toolkitRaw = tslib_1.__importStar(require("@reduxjs/toolkit"));
const services_1 = tslib_1.__importDefault(require("../../../../services"));
const deserializer_1 = tslib_1.__importDefault(require("../../../../utils/deserializer"));
const Booking_1 = tslib_1.__importDefault(require("../__models__/Booking"));
const getById_1 = tslib_1.__importDefault(require("../getById"));
const BookingItemPricePayload_1 = tslib_1.__importDefault(require("./__model__/BookingItemPricePayload"));
const updateBookingItemPrice = toolkitRaw.createAsyncThunk('bookings/fetch_update_booking_item_price', async (props, { rejectWithValue, dispatch }) => {
    try {
        const { data: attributes, bookingInternalId } = props;
        const data = new BookingItemPricePayload_1.default(bookingInternalId, attributes)
            .model;
        const response = await services_1.default.patch(`/api/saas/me/bookings/${props.bookingInternalId}`, data);
        const deserialized = (0, deserializer_1.default)(response.data);
        await dispatch((0, getById_1.default)({
            id: String(deserialized.data.internal_id),
        }));
        return new Booking_1.default(deserialized).data;
    }
    catch (eventError) {
        return rejectWithValue(eventError);
    }
});
const updateBookingItemPriceExtraReducers = (builder) => {
    builder.addCase(updateBookingItemPrice.pending, (state) => {
        state.booking.slices.items.loading = true;
    });
    builder.addCase(updateBookingItemPrice.fulfilled, (state) => {
        state.booking.slices.items.loading = false;
    });
    builder.addCase(updateBookingItemPrice.rejected, (state) => {
        state.booking.slices.items.loading = false;
    });
};
exports.updateBookingItemPriceExtraReducers = updateBookingItemPriceExtraReducers;
exports.default = updateBookingItemPrice;
//# sourceMappingURL=index.js.map